import React from 'react';
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';

type Props = {
  title: React.ReactNode;
  content: React.ReactNode;
  onConfirm: () => void;
  onClose: () => void;
  loading?: boolean;
  open?: boolean;
};

const DeleteConfirmationModal: React.FC<Props> = ({ title, content, onConfirm, onClose, loading, open }) => {
  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{content}</ModalBody>
        <ModalFooter>
          <Button colorScheme="red" mr={3} onClick={onConfirm} isLoading={loading} disabled={loading}>
            Delete
          </Button>
          <Button variant="outline" disabled={loading} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteConfirmationModal;
